import { useEffect, useState } from "react";
import { FaSync } from "react-icons/fa"
import useFetchRefreshDates from "./useFetchRefreshShipping";
import moment from "moment";
import styled from "styled-components";

const RefreshComponent = styled.div`
  display: inline-flex;
  gap: 5px;
  border-radius: 5px;
  background: rgb(222, 222, 222);
  padding: 5px 8px;
  font-weight: normal;
`

const RefreshIconWrapper = styled.span`
  display: flex;
  align-items: center;
  border-radius: 5px;
`

const RefreshIcon = styled(FaSync)`
  cursor: pointer;

  .busy > & {
    opacity: 0.3;
    animation: rotate 1.5s linear infinite;
    cursor: auto;
  }
`

const ShortDateWrapper = styled.span`
  display: flex;
  flex-direction: column;
  font-size: 10px;
  cursor: help; 
`

const ShortDate= styled.span`
`

export default ({
  text = 'Refresh',
  onStart,
  onComplete
}) => {
  const { fetchRefreshDates: fetchRefreshDatesHook, fetchRefreshShipping: fetchRefreshShippingHook } = useFetchRefreshDates()

  const [isBusy, setIsBusy] = useState()
  const [refreshDate, setRefreshDate] = useState()

  const { shippingRefreshStartEnd } = refreshDate || {}
  const displayDate = moment(shippingRefreshStartEnd).format('MM')
  const displayDate2 = moment(shippingRefreshStartEnd).format('DD')
  const hoverDate = ''+ 
`Last Updated Date:
${moment(shippingRefreshStartEnd)}`

  const onClick = async () => {
    if (isBusy) return

    const confirm = window.confirm('Are you sure you want to refresh all Shipping Data?')
    if (!confirm || isBusy) return

    onStart?.()
    setIsBusy(true)
    try {
      const refreshDate = await fetchRefreshShippingHook()
      setRefreshDate(refreshDate)
      onComplete?.()
    } catch (e) {
      onComplete?.({ error: e })
    } finally {
      setIsBusy(false)
    }
  }

  const fetchRefreshDates = async () => {
    const refreshDate = await fetchRefreshDatesHook()
    setRefreshDate(refreshDate)
  }
  
  useEffect(() => {
    fetchRefreshDates()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (<>
    <RefreshComponent>
      <RefreshIconWrapper className={(isBusy ? 'busy' : '')}>
        <RefreshIcon title={text} onClick={onClick} />
      </RefreshIconWrapper>

      <ShortDateWrapper title={hoverDate}>
        <ShortDate>{displayDate}</ShortDate>
        <ShortDate>{displayDate2}</ShortDate>
      </ShortDateWrapper>
    </RefreshComponent>
  </>)
}